import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { ComponentRegistration } from '../../../core';
import { ICustomerSettingsService } from '../../../services';
import { Dto } from '../../../data';
let template = require('./fpp-widget.html');

class FppWidgetComponent extends ComponentRegistration {

    constructor() {
        super('fppWidget', {
            controller: FppWidgetController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}

interface IFppWidgetController {

}

class FppWidgetController implements IFppWidgetController {
    private static $inject: Array<string> = ['CustomerSettings'];  
    private fppSettings: Dto.IFrequentParkerSettings;
    private enabledMessage: string;
    private defaultPromotionSettings: Dto.IPromotionSettings;
    private promotionsList: Array<Dto.IPromotionSettings>;

    constructor(private CustomerSettings: ICustomerSettingsService) {
        console.log('FppWidgetController loading');

    }

    public $onInit(): void {
        this.CustomerSettings.getFrequentParkerSettings()
            .then((response) => {
                this.fppSettings = response.settings;
                this.enabledMessage = (this.fppSettings.enabled) ? "Yes" : "No";
                this.schedulingBasis = this.getSchedulingBasisText(this.fppSettings.schedulingBasis);

                this.defaultPromotionSettings = Linq.From(this.fppSettings.promotionSettings)
                    .FirstOrDefault(x => x.isDefault === true);

                this.promotionsList = Linq.From(this.fppSettings.promotionSettings)
                    .Where(x => x.isActive === true && !x.isDefault).ToArray();
            });
    }
    private schedulingBasis: string;
    public getSchedulingBasisText(basis: Dto.SchedulingBasisType): string {
        switch (basis) {
            case Dto.SchedulingBasisType.EntryTime:
                return "Entry Times";
            case Dto.SchedulingBasisType.ExitTime:
                return "Exit Times";
            default:
                return "Not Configured";
        }
    }
}

let component = new FppWidgetComponent();
export default component;
export { component as FppWidgetComponent, IFppWidgetController, FppWidgetController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/setup/fpp-widget.ts